module.exports = __webpack_public_path__ + "img/img16.3e71ffd8.jpg";